import React from 'react';
import { Link } from 'react-router-dom';
import {
  LuArrowRight,
  LuBookOpen,
  LuBrain,
  LuCompass,
  LuGraduationCap,
  LuLayers,
  LuLock,
  LuRefreshCw,
  LuSparkles,
  LuUsers,
  LuZap,
  LuBookmark,
  LuChartColumn,
  LuShare2,
  LuLogIn,
} from 'react-icons/lu';
import { FEATURE_JOURNEY_INTRO, FEATURE_JOURNEY_STEPS } from '../../config/productJourneyTimeline';

const STEP_ICONS = {
  start: LuLogIn,
  'notebook-hub': LuLayers,
  discover: LuCompass,
  read: LuBookOpen,
  save: LuBookmark,
  practice: LuZap,
  review: LuRefreshCw,
  ai: LuSparkles,
  analytics: LuChartColumn,
  share: LuShare2,
  teams: LuUsers,
  trust: LuLock,
};

export default function FeaturesJourneyTimeline() {
  return (
    <div className="features-journey">
      <header className="features-journey-intro">
        <h2 className="features-journey-intro-title">{FEATURE_JOURNEY_INTRO.title}</h2>
        <p className="features-journey-intro-lead">{FEATURE_JOURNEY_INTRO.lead}</p>
        <p className="features-journey-loop">
          <LuGraduationCap aria-hidden />
          <span>{FEATURE_JOURNEY_INTRO.loopLabel}</span>
        </p>
      </header>

      <ol className="features-journey-track" aria-label="Product journey timeline">
        {FEATURE_JOURNEY_STEPS.map((item, index) => {
          const Icon = STEP_ICONS[item.id] || LuBrain;
          const isLast = index === FEATURE_JOURNEY_STEPS.length - 1;
          return (
            <li
              key={item.id}
              className={`features-journey-step${isLast ? ' features-journey-step--last' : ''}`}
            >
              <div className="features-journey-rail" aria-hidden>
                <span className="features-journey-node">
                  <Icon />
                </span>
                {!isLast && <span className="features-journey-line" />}
              </div>

              <article className="features-journey-card">
                <div className="features-journey-card-head">
                  <p className="features-journey-phase">{item.phase}</p>
                  <h3 className="features-journey-title">{item.title}</h3>
                  <p className="features-journey-hub">
                    <span className="features-journey-hub-label">{item.hub}</span>
                    {item.path && (
                      <Link to={item.path} className="features-journey-path">
                        {item.pathLabel}
                        <LuArrowRight aria-hidden />
                      </Link>
                    )}
                  </p>
                </div>
                <p className="features-journey-summary">{item.summary}</p>
                <ul className="features-journey-features">
                  {item.features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
                {item.planNote && (
                  <p className="features-journey-plan">
                    <LuSparkles aria-hidden />
                    {item.planNote}
                  </p>
                )}
              </article>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
